import React, { useEffect } from "react";
import { IIncrementalTableReport } from "../../../Interfaces/deltaHedgeSettings";
import { ITableUI } from "../../TableTemplate/tableTemplate";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import { setIncrementalTableFlag } from "../../../Features/DeltaHedgeSettings/deltaHedgeSettingsSlice";
import { CommonTableUI } from "../../TableTemplate/common";

const TableUI: React.FC<ITableUI<IIncrementalTableReport>> = ({
  reports,
  onAction,
  AdditionalBody,
}: ITableUI<IIncrementalTableReport>) => {
  const flag = useAppSelector(
    (store) => store.deltaHedgeSettingsSlice.incrementalTableRefetchFlag
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!!flag && onAction) {
      dispatch(setIncrementalTableFlag(false));
      onAction();
    }
  }, [flag]);
  return (
    <CommonTableUI
      reports={reports}
      onAction={onAction}
      AdditionalBody={AdditionalBody}
    />
  );
};

export default TableUI;
